const mapTextsDe = {
  "kartenLegende": "",
  "land": "Land",
  "risikokategorie": "Risikokategorie",
  "legendenKuerzel": "LK ",
  "engagement": "Engagement in CHF Mio.",
  "searchnomatch": "keine Ergebnisse",
  "backbutton": "zurück",
  "zero": "0,0",
  "newCommitment": "Neuengagement in CHF Mio.",

  "country": {
    "et": {
      "title": "Aethiopien",
      "region": "Afrika südlich der Sahara"
    },
    "gq": {
      "title": "Aeq. Guinea",
      "region": "Afrika südlich der Sahara"
    },
    "af": {
      "title": "Afghanistan",
      "region": "Südasien"
    },
    "eg": {
      "title": "Ägypten",
      "region": "Naher Osten & Nordafrika"
    },
    "al": {
      "title": "Albanien",
      "region": "Osteuropa & Zentralasien"
    },
    "dz": {
      "title": "Algerien",
      "region": "Naher Osten & Nordafrika"
    },
    "ao": {
      "title": "Angola",
      "region": "Afrika südlich der Sahara"
    },
    "ag": {
      "title": "Antigua & Barbuda",
      "region": "Lateinamerika & Karibik"
    },
    "an": {
      "title": "Antillen Niederländisch",
      "region": "Lateinamerika & Karibik"
    },
    "ar": {
      "title": "Argentinien",
      "region": "Lateinamerika & Karibik"
    },
    "am": {
      "title": "Armenien",
      "region": "Osteuropa & Zentralasien"
    },
    "aw": {
      "title": "Aruba",
      "region": "Lateinamerika & Karibik"
    },
    "az": {
      "title": "Aserbaidschan",
      "region": "Osteuropa & Zentralasien"
    },
    "au": {
      "title": "Australien",
      "region": "Ostasien & Pazifik"
    },
    "bs": {
      "title": "Bahamas",
      "region": "Lateinamerika & Karibik"
    },
    "bh": {
      "title": "Bahrain",
      "region": "Naher Osten & Nordafrika"
    },
    "bd": {
      "title": "Bangladesch",
      "region": "Südasien"
    },
    "bb": {
      "title": "Barbados",
      "region": "Lateinamerika & Karibik"
    },
    "by": {
      "title": "Belarus",
      "region": "Osteuropa & Zentralasien"
    },
    "be": {
      "title": "Belgien",
      "region": "Westeuropa"
    },
    "bz": {
      "title": "Belize",
      "region": "Lateinamerika & Karibik"
    },
    "bj": {
      "title": "Benin",
      "region": "Afrika südlich der Sahara"
    },
    "bm": {
      "title": "Bermuda",
      "region": "Lateinamerika & Karibik"
    },
    "bt": {
      "title": "Bhutan",
      "region": "Osteuropa & Zentralasien"
    },
    "bo": {
      "title": "Bolivien",
      "region": "Lateinamerika & Karibik"
    },
    "ba": {
      "title": "Bosnien und Herzegowina",
      "region": "Osteuropa & Zentralasien"
    },
    "bw": {
      "title": "Botswana",
      "region": "Afrika südlich der Sahara"
    },
    "br": {
      "title": "Brasilien",
      "region": "Lateinamerika & Karibik"
    },
    "bn": {
      "title": "Brunei",
      "region": "Südasien"
    },
    "bg": {
      "title": "Bulgarien",
      "region": "Osteuropa & Zentralasien"
    },
    "bf": {
      "title": "Burkina Faso",
      "region": "Afrika südlich der Sahara"
    },
    "bi": {
      "title": "Burundi",
      "region": "Afrika südlich der Sahara"
    },
    "cl": {
      "title": "Chile",
      "region": "Lateinamerika & Karibik"
    },
    "cn": {
      "title": "China",
      "region": "Ostasien & Pazifik"
    },
    "cr": {
      "title": "Costa Rica",
      "region": "Lateinamerika & Karibik"
    },
    "ci": {
      "title": "Côte d'Ivoire",
      "region": "Afrika südlich der Sahara"
    },
    "cw": {
      "title": "Curaçao",
      "region": "Lateinamerika & Karibik"
    },
    "dk": {
      "title": "Dänemark",
      "region": "Westeuropa"
    },
    "de": {
      "title": "Deutschland",
      "region": "Westeuropa"
    },
    "do": {
      "title": "Dominikanische Republik",
      "region": "Lateinamerika & Karibik"
    },
    "dj": {
      "title": "Dschibuti",
      "region": "Afrika südlich der Sahara"
    },
    "ec": {
      "title": "Ecuador",
      "region": "Lateinamerika & Karibik"
    },
    "sv": {
      "title": "El Salvador",
      "region": "Lateinamerika & Karibik"
    },
    "er": {
      "title": "Eritrea",
      "region": "Afrika südlich der Sahara"
    },
    "ee": {
      "title": "Estland",
      "region": "Osteuropa & Zentralasien"
    },
    "sz": {
      "title": "Eswatini",
      "region": "Afrika südlich der Sahara"
    },
    "fj": {
      "title": "Fidschi",
      "region": "Ostasien & Pazifik"
    },
    "fi": {
      "title": "Finnland",
      "region": "Westeuropa"
    },
    "fr": {
      "title": "Frankreich",
      "region": "Westeuropa"
    },
    "pf": {
      "title": "Französisch Polynesien",
      "region": "Ostasien & Pazifik"
    },
    "ga": {
      "title": "Gabun",
      "region": "Afrika südlich der Sahara"
    },
    "gm": {
      "title": "Gambia",
      "region": "Afrika südlich der Sahara"
    },
    "ge": {
      "title": "Georgien",
      "region": "Osteuropa & Zentralasien"
    },
    "gh": {
      "title": "Ghana",
      "region": "Afrika südlich der Sahara"
    },
    "gl": {
      "title": "Grönland",
      "region": "Nordic Countries"
    },
    "gd": {
      "title": "Grenada",
      "region": "Lateinamerika & Karibik"
    },
    "gr": {
      "title": "Griechenland",
      "region": "Westeuropa"
    },
    "gb": {
      "title": "Grossbritannien",
      "region": "Westeuropa"
    },
    "gp": {
      "title": "Guadeloupe",
      "region": "Lateinamerika & Karibik"
    },
    "gt": {
      "title": "Guatemala",
      "region": "Lateinamerika & Karibik"
    },
    "gn": {
      "title": "Guinea (Conakry)",
      "region": "Afrika südlich der Sahara"
    },
    "gw": {
      "title": "Guinea-Bissau",
      "region": "Afrika südlich der Sahara"
    },
    "gy": {
      "title": "Guyana",
      "region": "Lateinamerika & Karibik"
    },
    "ht": {
      "title": "Haiti",
      "region": "Lateinamerika & Karibik"
    },
    "hn": {
      "title": "Honduras",
      "region": "Lateinamerika & Karibik"
    },
    "hk": {
      "title": "Hongkong",
      "region": "Ostasien & Pazifik"
    },
    "in": {
      "title": "Indien",
      "region": "Südasien"
    },
    "id": {
      "title": "Indonesien",
      "region": "Ostasien & Pazifik"
    },
    "iq": {
      "title": "Irak",
      "region": "Naher Osten & Nordafrika"
    },
    "ir": {
      "title": "Iran",
      "region": "Naher Osten & Nordafrika"
    },
    "ie": {
      "title": "Irland",
      "region": "Westeuropa"
    },
    "is": {
      "title": "Island",
      "region": "Westeuropa"
    },
    "il": {
      "title": "Israel",
      "region": "Naher Osten & Nordafrika"
    },
    "it": {
      "title": "Italien",
      "region": "Westeuropa"
    },
    "jm": {
      "title": "Jamaika",
      "region": "Lateinamerika & Karibik"
    },
    "jp": {
      "title": "Japan",
      "region": "Ostasien & Pazifik"
    },
    "ye": {
      "title": "Jemen",
      "region": "Naher Osten & Nordafrika"
    },
    "jo": {
      "title": "Jordanien",
      "region": "Naher Osten & Nordafrika"
    },
    "kh": {
      "title": "Kambodscha",
      "region": "Ostasien & Pazifik"
    },
    "cm": {
      "title": "Kamerun",
      "region": "Afrika südlich der Sahara"
    },
    "ca": {
      "title": "Kanada",
      "region": "Nordamerika"
    },
    "cv": {
      "title": "Kap Verde",
      "region": "Afrika südlich der Sahara"
    },
    "kz": {
      "title": "Kasachstan",
      "region": "Osteuropa & Zentralasien"
    },
    "qa": {
      "title": "Katar",
      "region": "Naher Osten & Nordafrika"
    },
    "ke": {
      "title": "Kenia",
      "region": "Afrika südlich der Sahara"
    },
    "kg": {
      "title": "Kirgisistan (GUS)",
      "region": "Osteuropa & Zentralasien"
    },
    "ki": {
      "title": "Kiribati",
      "region": "Ostasien & Pazifik"
    },
    "co": {
      "title": "Kolumbien",
      "region": "Lateinamerika & Karibik"
    },
    "km": {
      "title": "Komoren",
      "region": "Afrika südlich der Sahara"
    },
    "cg": {
      "title": "Kongo (Brazzaville)",
      "region": "Afrika südlich der Sahara"
    },
    "cd": {
      "title": "Kongo (Kinshasa)",
      "region": "Afrika südlich der Sahara"
    },
    "kp": {
      "title": "Korea (Nord)",
      "region": "Südasien"
    },
    "kr": {
      "title": "Korea (Süd)",
      "region": "Südasien"
    },
    "xk": {
      "title": "Kosovo",
      "region": "Osteuropa & Zentralasien"
    },
    "hr": {
      "title": "Kroatien",
      "region": "Osteuropa & Zentralasien"
    },
    "cu": {
      "title": "Kuba",
      "region": "Lateinamerika & Karibik"
    },
    "kw": {
      "title": "Kuwait",
      "region": "Naher Osten & Nordafrika"
    },
    "la": {
      "title": "Laos",
      "region": "Südasien"
    },
    "ls": {
      "title": "Lesotho",
      "region": "Afrika südlich der Sahara"
    },
    "lv": {
      "title": "Lettland",
      "region": "Westeuropa"
    },
    "lb": {
      "title": "Libanon",
      "region": "Naher Osten & Nordafrika"
    },
    "lr": {
      "title": "Liberia",
      "region": "Afrika südlich der Sahara"
    },
    "ly": {
      "title": "Libyen",
      "region": "Naher Osten & Nordafrika"
    },
    "li": {
      "title": "Liechtenstein",
      "region": "Westeuropa"
    },
    "lt": {
      "title": "Litauen",
      "region": "Osteuropa & Zentralasien"
    },
    "lu": {
      "title": "Luxemburg",
      "region": "Westeuropa"
    },
    "mo": {
      "title": "Macau",
      "region": "Ostasien & Pazifik"
    },
    "mg": {
      "title": "Madagaskar",
      "region": "Afrika südlich der Sahara"
    },
    "mw": {
      "title": "Malawi",
      "region": "Afrika südlich der Sahara"
    },
    "my": {
      "title": "Malaysia",
      "region": "Ostasien & Pazifik"
    },
    "mv": {
      "title": "Malediven",
      "region": "Südasien"
    },
    "ml": {
      "title": "Mali",
      "region": "Afrika südlich der Sahara"
    },
    "mt": {
      "title": "Malta",
      "region": "Westeuropa"
    },
    "ma": {
      "title": "Marokko",
      "region": "Naher Osten & Nordafrika"
    },
    "mq": {
      "title": "Martinique",
      "region": "Lateinamerika & Karibik"
    },
    "mr": {
      "title": "Mauretanien",
      "region": "Afrika südlich der Sahara"
    },
    "mu": {
      "title": "Mauritius",
      "region": "Afrika südlich der Sahara"
    },
    "mk": {
      "title": "Mazedonien",
      "region": "Osteuropa & Zentralasien"
    },
    "mx": {
      "title": "Mexiko",
      "region": "Lateinamerika & Karibik"
    },
    "md": {
      "title": "Moldawien (GUS)",
      "region": "Osteuropa & Zentralasien"
    },
    "mn": {
      "title": "Mongolei",
      "region": "Osteuropa & Zentralasien"
    },
    "me": {
      "title": "Montenegro",
      "region": "Osteuropa & Zentralasien"
    },
    "mz": {
      "title": "Mosambik",
      "region": "Afrika südlich der Sahara"
    },
    "mm": {
      "title": "Myanmar (Birma)",
      "region": "Südasien"
    },
    "na": {
      "title": "Namibia",
      "region": "Afrika südlich der Sahara"
    },
    "np": {
      "title": "Nepal",
      "region": "Südasien"
    },
    "nz": {
      "title": "Neuseeland",
      "region": "Ostasien & Pazifik"
    },
    "ni": {
      "title": "Nicaragua",
      "region": "Lateinamerika & Karibik"
    },
    "nl": {
      "title": "Niederlande",
      "region": "Westeuropa"
    },
    "ne": {
      "title": "Niger",
      "region": "Afrika südlich der Sahara"
    },
    "ng": {
      "title": "Nigeria",
      "region": "Afrika südlich der Sahara"
    },
    "no": {
      "title": "Norwegen",
      "region": "Westeuropa"
    },
    "om": {
      "title": "Oman",
      "region": "Naher Osten & Nordafrika"
    },
    "at": {
      "title": "Österreich",
      "region": "Westeuropa"
    },
    "pk": {
      "title": "Pakistan",
      "region": "Südasien"
    },
    "pa": {
      "title": "Panama",
      "region": "Lateinamerika & Karibik"
    },
    "pg": {
      "title": "Papua-Neuguinea",
      "region": "Ostasien & Pazifik"
    },
    "py": {
      "title": "Paraguay",
      "region": "Lateinamerika & Karibik"
    },
    "pe": {
      "title": "Peru",
      "region": "Lateinamerika & Karibik"
    },
    "ph": {
      "title": "Philippinen",
      "region": "Ostasien & Pazifik"
    },
    "pl": {
      "title": "Polen",
      "region": "Osteuropa & Zentralasien"
    },
    "pt": {
      "title": "Portugal",
      "region": "Westeuropa"
    },
    "pr": {
      "title": "Puerto Rico",
      "region": "Lateinamerika & Karibik"
    },
    "re": {
      "title": "Réunion",
      "region": "Lateinamerika & Karibik"
    },
    "rw": {
      "title": "Ruanda",
      "region": "Afrika südlich der Sahara"
    },
    "ro": {
      "title": "Rumänien",
      "region": "Osteuropa & Zentralasien"
    },
    "ru": {
      "title": "Russland",
      "region": "Osteuropa & Zentralasien"
    },
    "": {
      "title": "Salomonen",
      "region": "Ostasien & Pazifik"
    },
    "zm": {
      "title": "Sambia",
      "region": "Afrika südlich der Sahara"
    },
    "as": {
      "title": "Samoa",
      "region": "Ostasien & Pazifik"
    },
    "st": {
      "title": "Sao Tomé & Principé",
      "region": "Afrika südlich der Sahara"
    },
    "sa": {
      "title": "Saudi-Arabien",
      "region": "Naher Osten & Nordafrika"
    },
    "se": {
      "title": "Schweden",
      "region": "Westeuropa"
    },
    "ch": {
      "title": "Schweiz",
      "region": "Westeuropa"
    },
    "sn": {
      "title": "Senegal",
      "region": "Afrika südlich der Sahara"
    },
    "rs": {
      "title": "Serbien",
      "region": "Osteuropa & Zentralasien"
    },
    "sc": {
      "title": "Seychellen",
      "region": "Afrika südlich der Sahara"
    },
    "sl": {
      "title": "Sierra Leone",
      "region": "Afrika südlich der Sahara"
    },
    "zw": {
      "title": "Simbabwe",
      "region": "Afrika südlich der Sahara"
    },
    "sg": {
      "title": "Singapur",
      "region": "Ostasien & Pazifik"
    },
    "sk": {
      "title": "Slowakei",
      "region": "Osteuropa & Zentralasien"
    },
    "si": {
      "title": "Slowenien",
      "region": "Westeuropa"
    },
    "so": {
      "title": "Somalia",
      "region": "Afrika südlich der Sahara"
    },
    "es": {
      "title": "Spanien",
      "region": "Westeuropa"
    },
    "lk": {
      "title": "Sri Lanka",
      "region": "Südasien"
    },
    "kn": {
      "title": "St. Kitts und Nevis",
      "region": "Lateinamerika & Karibik"
    },
    "vc": {
      "title": "St. Vincent & Grenadinen",
      "region": "Lateinamerika & Karibik"
    },
    "za": {
      "title": "Südafrika",
      "region": "Afrika südlich der Sahara"
    },
    "sd": {
      "title": "Sudan",
      "region": "Afrika südlich der Sahara"
    },
    "ss": {
      "title": "Südsudan",
      "region": "Afrika südlich der Sahara"
    },
    "sr": {
      "title": "Surinam",
      "region": "lateinamerika & Karibik"
    },
    "sy": {
      "title": "Syrien",
      "region": "Naher Osten & Nordafrika"
    },
    "tj": {
      "title": "Tadschikistan (GUS)",
      "region": "Osteuropa & Zentralasien"
    },
    "tw": {
      "title": "Taiwan (Chinesisches Taipei)",
      "region": "Ostasien & Pazifik"
    },
    "tz": {
      "title": "Tansania",
      "region": "Afrika südlich der Sahara"
    },
    "th": {
      "title": "Thailand",
      "region": "Ostasien & Pazifik"
    },
    "tp": {
      "title": "Timor-Leste",
      "region": "Südasien"
    },
    "tg": {
      "title": "Togo",
      "region": "Afrika südlich der Sahara"
    },
    "tk": {
      "title": "Trinidad und Tobago",
      "region": "Lateinamerika & Karibik"
    },
    "td": {
      "title": "Tschad",
      "region": "Afrika südlich der Sahara"
    },
    "cz": {
      "title": "Tschechische Republik",
      "region": "Osteuropa & Zentralasien"
    },
    "tn": {
      "title": "Tunesien",
      "region": "Naher Osten & Nordafrika"
    },
    "tr": {
      "title": "Türkei",
      "region": "Osteuropa & Zentralasien"
    },
    "tm": {
      "title": "Turkmenistan",
      "region": "Osteuropa & Zentralasien"
    },
    "tv": {
      "title": "Tuvalu",
      "region": "Ostasien & Pazifik"
    },
    "ug": {
      "title": "Uganda",
      "region": "Afrika südlich der Sahara"
    },
    "ua": {
      "title": "Ukraine",
      "region": "Osteuropa & Zentralasien"
    },
    "hu": {
      "title": "Ungarn",
      "region": "Osteuropa & Zentralasien"
    },
    "uy": {
      "title": "Uruguay",
      "region": "Lateinamerika & Karibik"
    },
    "uz": {
      "title": "Usbekistan",
      "region": "Osteuropa & Zentralasien"
    },
    "vu": {
      "title": "Vanuatu",
      "region": "Ostasien & Pazifik"
    },
    "ve": {
      "title": "Venezuela",
      "region": "Lateinamerika & Karibik"
    },
    "ae": {
      "title": "Vereinigte Arabische Emirate",
      "region": "Naher Osten & Nordafrika"
    },
    "us": {
      "title": "Vereinigte Staaten",
      "region": "Nordamerika"
    },
    "vn": {
      "title": "Vietnam",
      "region": "Ostasien & Pazifik"
    },
    "we": {
      "title": "Westjordanland und Gaza",
      "region": "Naher Osten & Nordafrika"
    },
    "cf": {
      "title": "Zentralafrik. Repubilk",
      "region": "Afrika südlich der Sahara"
    },
    "cy": {
      "title": "Zypern",
      "region": "Westeuropa"
    }
  }
};

export default mapTextsDe;
